define("shared/utils/constants/linkinbio-fonts", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.FONTS = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const FONTS = _exports.FONTS = [{
    name: 'Roboto',
    id: 'roboto',
    loaded: false
  }, {
    name: 'Raleway',
    id: 'raleway',
    loaded: false
  }, {
    name: 'Bellota',
    id: 'bellota',
    loaded: false
  }, {
    name: 'Courier Prime',
    id: 'courier-prime',
    loaded: false
  }, {
    name: 'Montserrat',
    id: 'montserrat',
    loaded: false
  }, {
    name: 'PT Serif',
    id: 'pt-serif',
    loaded: false
  }, {
    name: 'Playfair Display',
    id: 'playfair-display',
    loaded: false
  }, {
    name: 'Bodoni Moda',
    id: 'bodoni-moda',
    loaded: false
  }, {
    name: 'Charm',
    id: 'charm',
    loaded: false
  }, {
    name: 'Oswald',
    id: 'oswald',
    loaded: false
  }];
});